<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar v-if="showNav"></NavBar>
        <div class="deviceTestDIV container "> 
            <div class="wrapper mt-2">
                <div class="main-title">
                    {{ $t('DeviceTest.Title') }}
                </div>
            </div>
            
            <div class="accordion" id="TestAccordion">
                <!--喇叭測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headAudioOutput" :style="AudioOutputStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colAudioOutput" aria-expanded="false" aria-controls="colAudioOutput" :style="AudioOutputStyle">
                            {{ $t('DeviceTest.SpeakerTest.Title') }}
                        </div>
                    </div>
                    <div id="colAudioOutput" class="collapse deviceTestContent show" aria-labelledby="headAudioOutput" data-parent="#TestAccordion">
                        <div class="deviceTestBody">
                            <div class="d-flex justify-content-between flex-wrap py-1">
                                <AudioOutputTest></AudioOutputTest>  
                                <div class="d-flex deviceBtnGroup">
                                    <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getAUDIOOutputOK(true)" >{{ $t('DeviceTest.Button.Pass') }}</button>
                                    <button type="button" class="btn FAILBTN deviceTestBTN" v-on:click="getAUDIOOutputOK(false)" >{{ $t('DeviceTest.Button.Fail') }}</button>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                
                <!--麥克風測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headAudioInput" :style="AudioInputStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colAudioInput" aria-expanded="false" aria-controls="colAudioInput" :style="AudioInputStyle">
                            {{ $t('DeviceTest.MicrophoneTest.Title') }}
                        </div>
                    </div>
                    <div id="colAudioInput" class="collapse deviceTestContent" aria-labelledby="headAudioInput" data-parent="#TestAccordion">
                        <div class="deviceTestBody">
                            <div class="d-flex justify-content-between flex-wrap py-1">
                                <AudioInputTest></AudioInputTest> 
                                <div class="d-flex deviceBtnGroup">
                                    <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getAudioInputOK(true)" >{{ $t('DeviceTest.Button.Pass') }}</button>
                                    <button type="button" class="btn FAILBTN deviceTestBTN" v-on:click="getAudioInputOK(false)" >{{ $t('DeviceTest.Button.Fail') }}</button>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>

                <!--攝影機測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headVideo" :style="VideoStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colVideo" aria-expanded="false" aria-controls="colVideo" :style="VideoStyle">
                            {{ $t('DeviceTest.WebcamTest.Title') }}
                        </div>
                    </div>
                    <div id="colVideo" class="collapse deviceTestContent" aria-labelledby="headVideo" data-parent="#TestAccordion">
                        <div class="deviceTestBody ">
                            <div class="d-flex justify-content-between flex-wrap py-1">
                                <videoTEST></videoTEST>
                                <div class="d-flex deviceBtnGroup ">
                                    <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getVideoOK(true)" >{{ $t('DeviceTest.Button.Pass') }}</button>
                                    <button type="button" class="btn FAILBTN deviceTestBTN" v-on:click="getVideoOK(false)" >{{ $t('DeviceTest.Button.Fail') }}</button>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                
                <!--瀏覽器測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headOne" v-bind:style="BrowserStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#coldeviceTest" aria-expanded="false" aria-controls="coldeviceTest" v-bind:style="BrowserStyle" v-on:click="getChromeVersion()">
                            {{ $t('DeviceTest.BrowserTest.Title') }}
                        </div>
                    </div>
                    <div id="coldeviceTest" class="collapse deviceTestContent" aria-labelledby="headOne" data-parent="#TestAccordion">
                        <div class=" deviceTestBody d-flex justify-content-between">
                            <!--<span>瀏覽器版本需更新至最新版.</span> -->
                            <span>{{ $t('DeviceTest.BrowserTest.ChromeConfirm1') }}<code>{{ChromeVersion}}</code>{{ $t('DeviceTest.BrowserTest.ChromeConfirm2') }}</span> 
                            <!--<div>
                                <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getChromeVersion" >OK</button>
                            </div>-->
                        </div>
                    </div>
                </div>

                <!--網速測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headNetSpeed" v-bind:style="NetStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colNetSpeed" aria-expanded="false" aria-controls="colNetSpeed" v-bind:style="NetStyle">
                            {{ $t('DeviceTest.NetworkTest.Title') }}
                        </div>
                    </div>
                    <div id="colNetSpeed" class="collapse deviceTestContent" aria-labelledby="headNetSpeed" data-parent="#TestAccordion">
                        <div class="deviceTestBody">
                            <netTest></netTest>
                            <!--<button type="button" class="btn OKBTN deviceTestBTN"  v-on:click="getNetOK">OK</button>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--confirm button-->
        <div class="d-flex justify-content-center p-2 footerNAV">
            <button class="mx-2 ShareBTN" v-on:click="skipTest" v-if="IsSpeedTest">
                    {{ $t('DeviceTest.SkipTesting') }}
            </button>
            <button class="mx-2 ShareBTN" v-on:click="saveTestResult">
                <!--<router-link :to="`/index`">-->
                    <!--完成(儲存測試結果)-->
                    {{ $t('DeviceTest.TestingCompleted') }}
                <!--</router-link>-->
            </button>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

import AudioOutputTest from '@/components/DeviceTestPages/AudioOutputTest'
import videoTEST from '@/components/DeviceTestPages/videoTest'
import AudioInputTest from '@/components/DeviceTestPages/AudioInputTest'
import netTest from '@/components/DeviceTestPages/netTest'

export default {
    name: 'deviceTest',
    components:{
        NavBar,videoTEST,AudioInputTest,netTest,AudioOutputTest
    },
    data () {
        return {
            // Token:'',
            showNav:true,
            UserId:'',
            showLoading:false,
            ChromeVersion:'100.0',
            NowBrowserVersion:'',
            browser:'',
            version:'',
            OS:'',
            IP:'',
            Model:'',
            BrowserStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            AudioOutputStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            AudioInputStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            NetStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            VideoStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            OKStyle:{backgroundColor: "#99C3D9",color:"#3D708F"},
            NotOKStyle:{backgroundColor: "#E47451",color:"white"},
            IsSpeedTest:false,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || 'DeviceTest 設備檢測';
            }
        },
    },
    methods:{        
        getChromeVersion: function () {
            this.browserVersionType()
            this.BrowserStyle = this.OKStyle;
            /*var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            this.NowBrowserVersion=raw[2];
            if (parseFloat(raw[2], 10) >= parseFloat(this.ChromeVersion)){// Version OK
                this.BrowserStyle = this.OKStyle;
            }else{// Version NOT OK
                this.BrowserStyle = this.NotOKStyle;
                alert("Google Chrome目前版本為"+parseFloat(raw[2], 10)+"，請更新。");
            }*/
        },
        getAUDIOOutputOK(Status){
            if(!Status){
                this.AudioOutputStyle = this.NotOKStyle;
            }else if(this.GLOBAL.AUDIOOutputOK){
                this.AudioOutputStyle = this.OKStyle;
                var output = document.querySelector('#colAudioOutput').classList.remove('show');
                var input = document.querySelector('#colAudioInput').classList.add('show');
            }else{
                if(Status){//not OK but click OK BTN 
                    alert(this.$t('DeviceTest.SpeakerTest.NoDevice'));
                }
                this.AudioOutputStyle = this.NotOKStyle;
            }
        },
        getAudioInputOK(Status){
            if(!Status){
                this.AudioInputStyle = this.NotOKStyle;
            }else if(this.GLOBAL.AUDIOInputOK){
                this.AudioInputStyle = this.OKStyle;
                var output = document.querySelector('#colAudioInput').classList.remove('show');
                var input = document.querySelector('#colVideo').classList.add('show');
            }else{
                if(Status){//not OK but click OK BTN 
                    alert(this.$t('DeviceTest.MicrophoneTest.NoDevice'));
                }
                this.AudioInputStyle = this.NotOKStyle;
            }
        },      
        getVideoOK(Status){
            if(!Status){
                this.VideoStyle = this.NotOKStyle;
            }else if(this.GLOBAL.VideoOK){
                this.VideoStyle = this.OKStyle;
                var output = document.querySelector('#colVideo').classList.remove('show');
                var input = document.querySelector('#deviceTest').classList.add('show');
            }else{
                if(Status){//not OK but click OK BTN 
                    alert(this.$t('DeviceTest.WebcamTest.NoDevice'));
                }
                this.VideoStyle = this.NotOKStyle;
            }
        },  
        getNetOK(){
            if(this.GLOBAL.NetOK){
                this.NetStyle = this.OKStyle;
            }else{
                this.NetStyle = this.NotOKStyle;
            }
        },
        saveTestResult(){
            this.getIP();
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/SaveDeviceTestingLog`;
            const inputdata = 
            {
                "UserId": this.UserId,
                "MicrophoneDevice": this.GLOBAL.selectedAudioInput,
                "MicrophoneResult": this.GLOBAL.AUDIOInputOK,
                "AudioDevice": this.GLOBAL.selectedAudioOutput,
                "AudioOutputResult": this.GLOBAL.AUDIOOutputOK,
                "CameraDevice": this.GLOBAL.selectedCamera,
                "CameraResult": this.GLOBAL.VideoOK,
                "UploadSpeed": this.GLOBAL.UploadSpeed,
                "DownloadSpeed":  this.GLOBAL.DownloadSpeed,
                "Ping":  this.GLOBAL.Ping,
                // "Jitter": 32.2,
                "Os": this.OS,
                "Model": this.Model ,
                "Browser": this.Browser,
                "BrowserVersion": this.NowBrowserVersion,
                "Ip": this.IP,
                "Comment": ""
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        if(this.$route.params.ClassroomUrl != undefined){
                            window.open(this.$route.params.ClassroomUrl, '_blank');
                        }else{
                            alert(this.$t('DeviceTest.Save.Successful'))
                        }
                    }else{

                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                        alert("this.$t('DeviceTest.Save.Failed')："+error);
                });
        },
        skipTest(){
            if(this.$route.params.ClassroomUrl != undefined){
                window.open(this.$route.params.ClassroomUrl, '_blank');
            }
        },
        deviceType(){
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "desktop";
        },
        browserVersionType(){
            var nAgt = navigator.userAgent;
            var verOffset = '';
            // var version = '';
            // Opera
            if ((verOffset = nAgt.indexOf('Opera')) != -1) {
                this.browser = 'Opera';
                this.NowBrowserVersion = nAgt.substring(verOffset + 6,verOffset + 6+(nAgt.substring(verOffset + 6)).indexOf(' '));
                if ((verOffset = nAgt.indexOf('Version')) != -1) {
                    this.NowBrowserVersion = nAgt.substring(verOffset + 8,verOffset + 8+(nAgt.substring(verOffset + 8)).indexOf(' '));
                }
            }
            // Opera Next
            if ((verOffset = nAgt.indexOf('OPR')) != -1) {
                this.browser = 'Opera';
                this.NowBrowserVersion = nAgt.substring(verOffset + 4,verOffset + 4+(nAgt.substring(verOffset + 4)).indexOf(' '));
            }
            // Legacy Edge
            else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
                this.browser = 'Microsoft Legacy Edge';
                this.NowBrowserVersion = nAgt.substring(verOffset + 5,verOffset + 5+(nAgt.substring(verOffset + 5)).indexOf(' '));
            } 
            // Edge (Chromium)
            else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
                this.browser = 'Microsoft Edge';
                this.NowBrowserVersion = nAgt.substring(verOffset + 4,verOffset + 4+(nAgt.substring(verOffset + 4)).indexOf(' '));
            }
            // MSIE
            else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
                this.browser = 'Microsoft Internet Explorer';
                this.NowBrowserVersion = nAgt.substring(verOffset + 5,verOffset + 5+(nAgt.substring(verOffset + 5)).indexOf(' '));
            }
            // Chrome
            else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
                this.browser = 'Chrome';
                this.NowBrowserVersion = nAgt.substring(verOffset + 7,verOffset + 7+(nAgt.substring(verOffset + 7)).indexOf(' '));
            }
            // Safari
            else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
                this.browser = 'Safari';
                this.NowBrowserVersion = nAgt.substring(verOffset + 7,verOffset + 7+(nAgt.substring(verOffset + 7)).indexOf(' '));
                if ((verOffset = nAgt.indexOf('Version')) != -1) {
                    this.NowBrowserVersion = nAgt.substring(verOffset + 8,verOffset + 8+(nAgt.substring(verOffset + 8)).indexOf(' '));
                }
            }
            // Firefox
            else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
                this.browser = 'Firefox';
                this.NowBrowserVersion = nAgt.substring(verOffset + 8,verOffset + 8+(nAgt.substring(verOffset + 8)).indexOf(' '));
            }
            // MSIE 11+
            else if (nAgt.indexOf('Trident/') != -1) {
                this.browser = 'Microsoft Internet Explorer';
                this.NowBrowserVersion = nAgt.substring(nAgt.indexOf('rv:') + 3,nAgt.indexOf('rv:') + 3+(nAgt.substring(nAgt.indexOf('rv:') + 3)).indexOf(' '));
            }
            // Other this.browsers
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                this.browser = nAgt.substring(nameOffset, verOffset);
                this.NowBrowserVersion = nAgt.substring(verOffset + 1,verOffset + 1+(nAgt.substring(verOffset + 1)).indexOf(' '));
                if (this.browser.toLowerCase() == this.browser.toUpperCase()) {
                    this.browser = navigator.appName;
                }
            }
            return this.browser;
        },
        OSType(){
            var OSName = "Unknown";
            if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSName="Windows 10";
            if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1) OSName="Windows 8.1";
            if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName="Windows 8";
            if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName="Windows 7";
            if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName="Windows Vista";
            if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName="Windows XP";
            if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName="Windows 2000";
            if (window.navigator.userAgent.indexOf("Mac")            != -1) OSName="Mac/iOS";
            if (window.navigator.userAgent.indexOf("X11")            != -1) OSName="UNIX";
            if (window.navigator.userAgent.indexOf("Linux")          != -1) OSName="Linux";
            if (window.navigator.userAgent.indexOf("Android")        != -1) OSName="Android";
            if (window.navigator.userAgent.indexOf("MeeGo")          != -1) OSName="MeeGo";
            return OSName;
        },
        getIP(){
            const url = 'https://api.ipify.org?format=json'
            axios.get(url).then(response => {
                this.IP = response.data.ip;
                // console.log(this.IP)
                return response.data.ip;
            })
        },
    },    
    created(){
        if(this.$route.query.UserId != undefined){
            this.showNav = false;
            this.UserId = this.$route.query.UserId.toString();
        }else{
            this.showNav = true;
            this.UserId = sessionStorage.getItem('StudentUserId');
        }
        this.IP = this.getIP();
        this.OS = this.OSType();
        this.Model = this.deviceType();
        this.Browser = this.browserVersionType();
        this.$root.$refs.deviceTest = this;
        this.$root.$refs.OS = this.OS;
        this.IsSpeedTest = this.$route.params.IsSpeedTest == undefined ? false : this.$route.params.IsSpeedTest;
    }    
}
</script>





// WEBPACK FOOTER //
// src/components/pages/deviceTest.vue